import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Submission } from '../../../../team-apis/otterdam/submission';

@Component({
  selector: 'h3-read-only-workspace-navbar',
  templateUrl: './read-only-workspace-navbar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ReadOnlyWorkspaceNavbarComponent {
  @Input() submissions?: Submission[];
  @Input() stepId?: number;
}
